// import 'bootstrap/dist/js/bootstrap'
import "bootstrap";

// include through webpack.ProvidePlugin with exports-loader
import "bootstrap/js/dist/util";

import Popper from "popper.js";
/* import Tooltip from 'bootstrap/js/dist/tooltip' */
import Popover from "bootstrap/js/dist/popover";

import "bootstrap/dist/css/bootstrap.min.css";

/* import validation plugin */
import validator from "jquery-validation/dist/jquery.validate.min.js";

/* Importing style */
require("../style/general.scss");
require("../style/_custom.css");

$(document).ready(function () {
    $('.carousel').carousel({
        interval: 12000
    });

    $('#issuesModal').on('show.bs.modal', function (event) {

        var button = $(event.relatedTarget);
        var content = button.data('content');
        var title = button.data('title');
        var modalclass = button.data('class');

        var modal = $(this);
        modal.find('.modal-header').addClass(modalclass);
        modal.find('.modal-title .modal-title-text').text(title);
        modal.find('.modal-body').html(content);
    });

    $('.mega-dropdown .dropdown-menu').on('click', function (e) {
        e.stopPropagation();
    });

    $('#load-more-news').click(function (e) {
        e.preventDefault();

        var idSec = $(this).attr('data-visible');

        var targetID = '#news-section-' + idSec;

        console.log(targetID);

        $(targetID).removeClass('d-none');

        var sectionID = parseInt($(this).attr('data-visible'));

        if (sectionID == 4) {
            $(this).addClass('d-none');
            $('#news-separator').addClass('d-none');
        } else {
            sectionID += 1;
            $(this).attr('data-visible', sectionID);
            console.log('more');
        }



    });

}); //End of $(document).ready(...)



// WEBPACK FOOTER //
// ./src/js/main.js